import '../../../css/Buttons/RadioButton.css';

const RadioButton = ({ label, checked, onChange }) => {
  return (
    <label className={`AML-RadioButton ${checked ? 'checked' : ''}`}>
      <input type="radio" checked={checked} onChange={onChange} />
      <div className="AML-Text-Input"> {label}</div>
    </label>
  );
};
export default RadioButton;
